var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-habilitado"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"400px"},attrs:{"src":"public/images/site/stop.svg","id":"challenges","alt":"Inmersivo"}}),_vm._v(" "),_c('h2',[_vm._v("Contenido restringido a")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.perfil))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94302a36","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/NoHabilitado.vue
// module id = 517
// module chunks = 0